
import { defineComponent, onActivated, onDeactivated, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { analyse_day_appointment, query_shop_list } from '@/api/mjstore-model';
import { queryMyShopList } from '@/api/user/login';
import { checkIsSuperUser } from '@/api/sys/index.ts';
import { useStore } from 'vuex';
import PageModel2 from '@/components/page-model2/index.vue';
import bus from '@/utils/bus';
import moment from 'moment';

export default defineComponent({
  setup() {
    const route = useRoute();
    const store = useStore();
    const tableHeight = reactive({ y: window.innerHeight - 230 });
    const event_bus = bus;
    route.meta.title = route.params['name'];
    const current_org = store.getters['user/current_org'];
    const is_show: any = ref(false);
    const is_update: any = ref(true);
    const title: any = ref('');
    query_shop_list({
      org_id: current_org?.id,
      ids: [route.params['id']],
    }).then((res: any) => {
      if (res && res.data && res.data.length > 0) {
        title.value = res.data[0].name + '(' + route.params['name'] + ')';
      } else {
        title.value = '(' + route.params['name'] + ')';
      }
    });
    const get_is_update = () => {
      queryMyShopList({
        org_id: current_org?.id,
      }).then((res: any) => {
        let is_close: any = false;
        if (res && res.data && res.data.length > 0) {
          res.data.map((item: any) => {
            if (item.id == route.params['id']) {
              is_close = true;
            }
          });
        }
        if (is_close) {
          is_update.value = true;
        } else {
          is_update.value = false;
        }
      });
    };
    if (route.params['name'] >= moment().format('YYYY-MM-DD')) {
      checkIsSuperUser({
        org_id: current_org?.id,
      }).then((res: any) => {
        if (res.is_super_user.value) {
          is_update.value = true;
        } else {
          get_is_update();
        }
      });
    } else {
      is_update.value = false;
    }

    const dataSource: any = ref([]);
    const dynamicColumns: any = ref([]);
    const order_obj = reactive({
      no_coming_num: 0,
      no_order_num: 0,
      order_coming_num: 0,
      order_num: 0,
    });
    const refresh = () => {
      analyse_day_appointment({
        org_id: current_org?.id,
        check_date: route.params['name'],
        shop_id: route.params['id'],
      }).then((res: any) => {
        is_show.value = false;
        order_obj.no_coming_num = res.no_coming_num;
        order_obj.no_order_num = res.no_order_num;
        order_obj.order_coming_num = res.order_coming_num;
        order_obj.order_num = res.order_num;
        dynamicColumns.value.push({
          title: res.appointment_title_list.join("/"),
          dataIndex: 'time',
          fixed: 'left',
          width: 100,
        });
        res.staff_list.map((item: any, index: any) => {
          dynamicColumns.value.push({
            title: item.name,
            dataIndex: item.code,
            id: item.id,
            is_update: is_update.value,
            shop_id: route.params['id'],
            date: route.params['name'],
            width: 250,
            cellComponent: 'click_order',
            content: (record: any, text: any) => {
              if (text.appointment_id) {
                return text.customer__name + '-' + text.project__name;
              } else {
                return '';
              }
            },
          });
        });
        dataSource.value = res.data_list;
        dataSource.value.map((item: any, index: any) => {
          if (index > 0) {
            for (let key in item) {
              if (key != 'time' && dataSource.value[index - 1][key].customer_id) {
                dataSource.value[index][key].up_customer_id =
                  dataSource.value[index - 1][key].customer_id;
              }
              if (key != 'time' && dataSource.value[index - 1][key].project_id) {
                dataSource.value[index][key].up_project_id =
                  dataSource.value[index - 1][key].project_id;
              }
            }
          } else {
            for (let key in item) {
              if (key != 'time') {
                dataSource.value[index][key].up_customer_id = null;
                dataSource.value[index][key].up_project_id = null;
              }
            }
          }
        });
        console.log('dataSource.value', dataSource.value);
        is_show.value = true;
      });
    };
    refresh();
    const customCell = (obj: any) => {
      if (obj.record[obj.column.dataIndex].is_order) {
        return { style: { background: '#fda6ab' } };
      }
    };

    event_bus?.on('refresh_order', refresh);

    onActivated(() => {
      event_bus?.off('refresh_order', refresh);
      // 先解监听，再监听，防止重复
      event_bus?.on('refresh_order', refresh);
    });
    onDeactivated(() => {
      event_bus?.off('refresh_order', refresh);
    });

    return {
      tableHeight,
      dynamicColumns,
      is_update,
      route,
      is_show,
      dataSource,
      order_obj,
      customCell,
      title,
    };
  },
  components: {
    PageModel2,
  },
});
